import { inject } from '@angular/core';
import { ResolveFn, Routes } from '@angular/router';
import { AppPropertyBasicModel, HxOrganizationService, OrganizationModel } from 'hx-services';
import { OrganizationListComponent } from '@adm-web-app/modules/organizations/list/organization-list.component';
import { OrganizationEditComponent } from '@adm-web-app/modules/organizations/edit/organization-edit.component';
import { OrganizationPropertyListComponent } from '@adm-web-app/modules/organizations/properties/list/list.component';
import { OrganizationPropertyEditComponent } from '@adm-web-app/modules/organizations/properties/edit/edit.component';

const organizationResolveFn: ResolveFn<OrganizationModel> = route => inject(HxOrganizationService)
  .getOrganizationById(Number(route.paramMap.get('orgId')));

const organizationPropertyResolveFn: ResolveFn<AppPropertyBasicModel | null> = route => inject(HxOrganizationService)
  .getPropertyByKey(Number(route.paramMap.get('orgId')), String(route.paramMap.get('key')));

const organizationInfoPropertyResolveFn: ResolveFn<AppPropertyBasicModel | null> = route => inject(HxOrganizationService)
  .getPropertyByKey(Number(route.paramMap.get('orgId')), 'org-info');

export const orgRoutes: Routes = [
  {
    path: '', component: OrganizationListComponent,
    data: {
      breadcrumb: 'List'
    }
  },
  {
    path: 'new', component: OrganizationEditComponent,
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':orgId/edit', component: OrganizationEditComponent,
    resolve: {
      model: organizationResolveFn,
      info: organizationInfoPropertyResolveFn,
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
  {
    path: ':orgId/properties', component: OrganizationPropertyListComponent,
    resolve: {
      organization: organizationResolveFn
    },
    data: {
      breadcrumb: 'Properties'
    }
  },
  {
    path: ':orgId/properties/new', component: OrganizationPropertyEditComponent,
    resolve: {
      organization: organizationResolveFn,
    },
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':orgId/properties/:key/edit', component: OrganizationPropertyEditComponent,
    resolve: {
      organization: organizationResolveFn,
      property: organizationPropertyResolveFn
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
];
